import { render } from "./OdCopyButton.vue?vue&type=template&id=5f2d27c6"
import script from "./OdCopyButton.vue?vue&type=script&lang=js"
export * from "./OdCopyButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__